export default "__VITE_ASSET__nES$ROnP__"